import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

module.exports = {
    createFetchParams: period => ({
        date: Math.floor(period.startDate / TIMESTAMP_MULTIPLY) }),
    ...storeModuleFactory({
        name:               'objectStorageVolume',
        endpoint:           endpoints.storage.storageObjectVolume,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        transformResultsFn: response => {
            if (response.results) {
                return response.results.map(item => ({
                    value: item.id,
                    label: item.name
                }));
            }

            return [];
        }
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/objectStorageVolume.js